import { createContext } from 'react';

/**
 * @typedef {{ config: { asyncChatEnabled: boolean; useMarketplaceId: boolean; isGlobalStoreCountry: boolean; }}} GlobalConfig
 */

/**
 * @typedef {object} StoreType
 * @property {Object.<string, boolean> & GlobalConfig} flags
 * @property {{ header: object, footer: object }} globalNavData
 * @property {boolean} isScrimOpen
 * @property {boolean} isSearchOpen
 * @property {boolean} isTopBarVisible
 * @property {import('../utils/hooks/localeHook').Locale} locale
 * @property {{ NES_COMMIT_SHA: string, generationId: string, timestamp: Date, version: string, branch: string }} metadata
 * @property {Object.<string, string>} translations
 */

/**
 * @typedef {object} ActionsType
 * @property {function(boolean):void} setTopBarIsVisible
 * @property {function(boolean):void} setIsLoggedIn
 * @property {function(object):void} setUserProfile
 * @property {function(boolean):void} setIsScrimOpen
 * @property {function(boolean):void} setIsSearchOpen
 */

/**
 * @typedef {[StoreType, ActionsType]} AppContextType
 */

/**
 * The application context
 * @type {React.Context<AppContextType>}
 * */
export const AppContext = createContext();
